/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import { useDataContext } from '../context';

const API_URL = import.meta.env.VITE_API_URL;

function GetProvinces() {
  const { data, setData } = useDataContext();
  const hasFetched = useRef(false);

  useEffect(() => {
    if (data.allProvinces && data.allProvinces.length > 0) return;
    if (hasFetched.current) return;

    const fetchData = async () => {
      hasFetched.current = true;
      try {
        const response = await fetch(`${API_URL}/provinces`, { method: "GET", redirect: "follow" });
        const result = await response.json();
        setData(prev => ({ ...prev, allProvinces: result.data || [] }));
      } catch (error) {
        console.error("Error fetching provinces:", error);
        hasFetched.current = false;
      }
    };

    fetchData();
  }, []);

  return null;
}

export default GetProvinces;